import {customAlphabet} from 'nanoid';

import {StatusCode} from 'common/util/shared-client';
import {ToastType} from 'common/components/toast/types';
import {addToast} from 'common/components/toast-area/toast-manager';
import {reporter} from 'common/report/error-reporting';
import {ReportName} from 'common/report/constants';
import {base58alphabet} from 'common/report/util/public/uuid-helpers';

export enum BookmarkURLTrackEvents {
  LoadLongURL = `[Cleaner URL] Load Long URL`,
}

export type LoadLongURLTrackingProps = {
  tab: ReportName;
  'Bookmark ID'?: number;
  'Is Fastedit Mode'?: boolean;
};

const SLUG_LENGTH = 12;

// We're now using base58 rather than base64. Keeping base64 regex for now to maintain support for existing base64
// slugs (only internal projects during dogfooding). Can change regex to base58 (here and in server validation) in
// the future once usage of base64 slugs approaches 0 (although probably not worth the effort)
const SLUG_REGEX = new RegExp(`^[0-9a-zA-Z_-]{${SLUG_LENGTH}}$`);

export function isValidBookmarkURLSlug(shortCode: string): boolean {
  return Boolean(SLUG_REGEX.exec(shortCode));
}

const base58NanoId = customAlphabet(base58alphabet);

export function generateBookmarkURLSlug() {
  return base58NanoId(SLUG_LENGTH);
}

export function handleFetchBookmarkURLError(err, params: {slug: string; projectId: number; reportName: ReportName}) {
  reporter.error(err, `Error fetching bookmark URL`, params);

  let message = `Error loading report`;

  if (err.status === StatusCode.NotFound) {
    message = `Report does not exist`;
  }

  addToast({message, type: ToastType.ERROR});
}
